import { AxiosError } from 'axios';

import { NotFoundException } from 'app/api/exception/NotFoundException';
import { Interceptor } from 'app/api/interceptor/Interceptor';

export class NotFoundErrorInterceptor implements Interceptor {
    process(error: AxiosError): void {
        if (error.response.status === 404) {
            throw new NotFoundException();
        }
    }
}
